import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import CountryConfigContext from "../CountryConfigContext";
import menu from "@ui-components/AppNavigation/menu";
import CountryContext from "../CountryContext";
import AuthenticationService from "../services/AuthenticationService";
import {evaluateRule} from "@ui-components/AppNavigation/utilities";

const Home = () => {
  const {
    country: { code },
  } = useContext(CountryContext);
  const { config } = useContext(CountryConfigContext);
  const { role_type } = AuthenticationService.getUserData();

  const activeHomeRoutes = menu
    .reduce(
      // Flatten dropdown items into a single array
      (acc, route) => [
        ...acc,
        ...(!!route.dropdown ? route.dropdown : [route])
      ],
      []
    )
    .filter(({home, homeNegate}) => {
      // Check if the route is visible as a home button (possibly negated)
      const isVisible = !!home
        ? evaluateRule(home, [role_type], code)
        : false;
      return homeNegate === true ? !isVisible : isVisible;
    })
    .reduce((acc, route) => {
      if (!route.externalHref) {
        return [...acc, route];
      }

      const external = config.config.find((row) => {
        return row.key === route.externalHref;
      });

      if (!external) {
        return acc;
      }
      return [...acc, { ...route, configHref: external.value }];
    }, []);

  return (
    <div>
      <div
        className="flex flex-col"
        style={{
          bottom: 0,
          minHeight: "100vh",
          // backgroundImage: `url(${
          //   process.env.PUBLIC_URL + "/Kerakoll-Illustrazione-pari.svg"
          // })`,
          backgroundSize: "contain",
          backgroundPosition: "bottom",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="mt-10 md:mt-34">
          <h1 className="text-black-500 text-5xl">Genius Lab Building Platform</h1>
        </div>
        <div className="border-t-2 my-12 border-black-500" />
        <div className="flex flex-col grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
          {activeHomeRoutes.map(
            ({ name, initialUrl, href, configHref, description }) => {
              const content = (
                <div className="flex flex-col">
                  <p className="font-semibold text-2xl">
                    <FormattedMessage id={name} />
                  </p>
                  {description ? (
                    <p>
                      <FormattedMessage id={description} />
                    </p>
                  ) : null}
                </div>
              );

              const classes =
                "w-full border-2 border-black-500 px-4 pt-3 pb-4 cursor-pointer hover:bg-am-500 hover:text-white text-am-500 bg-white";

              if (configHref) {
                return (
                  <a
                    rel="noreferrer"
                    key={name}
                    className={classes}
                    href={configHref}
                    target="_blank"
                  >
                    {content}
                  </a>
                );
              }

              return (
                <Link
                  key={name}
                  to={`/${code}${initialUrl || href}`}
                  className={classes}
                >
                  {content}
                </Link>
              );
            }
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
